import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from '../../services/session'
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const LocService = new Loc()
const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            locale: LocService,
            id: null,
            name: '',
            allCustomCategories: [],
            selectedCustomCategories: [],
            model: {
                id: null,
                username: null,
                password: null,
                deviceUrl: null,
                companyName: '',
                location: null
            }
        }
    },
    methods: {
        update: update,
        isNull: isNull,
        getChipClass: getChipClass,
        clickSelectCustomCategory: clickSelectCustomCategory,
        isSelected: isSelected,
        getHikvisionConfig: getHikvisionConfig,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        let customCategories = session.getConfig().customCategories;
        this.allCustomCategories = customCategories != null && customCategories.length > 0 ? customCategories.split(";") : [];
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.model.companyName = this.name;
        this.getHikvisionConfig()
    }
}

function getHikvisionConfig() {
    let _self = this;
    let location = null;
    if (this.selectedCustomCategories.length > 0) {
        location = this.selectedCustomCategories[0];
    }
    AdminApiService.getHikvisionConfig(this.name, location)
        .then((response) => {
            _self.model.id = _self.isNull(response.data.id, null);
            _self.model.username = _self.isNull(response.data.username, null);
            _self.model.password = _self.isNull(response.data.password, null);
            _self.model.deviceUrl = _self.isNull(response.data.deviceUrl, null);
            _self.model.companyName = _self.isNull(response.data.companyName, _self.name);
            _self.model.location = _self.isNull(response.data.location, location);
            _self.id = _self.model.id;
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function isNull(value, def) {
    if (value == null) return def
    return value
}

function update() {
    let _self = this;
    let location = null;
    if (this.selectedCustomCategories.length > 0) {
        location = this.selectedCustomCategories[0];
    }
    this.model.companyName = this.name;
    this.model.location = location;
    this.model.id = this.id;

    AdminApiService.updateHikvisionConfig(this.model)
        .then((response) => {
            swal('Success', 'Konfiguracija ažurirana', 'success')
            _self.getHikvisionConfig();
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getChipClass(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        this.selectedCustomCategories = this.selectedCustomCategories.filter(e => e !== item)
    } else {
        this.selectedCustomCategories = []
        this.selectedCustomCategories.push(item)
    }
    this.getHikvisionConfig();
}



// WEBPACK FOOTER //
// ./src/components/Company/HikConfig.js